<template>
  <div>
    <v-divider></v-divider>
    <v-layout class="mt-2">
      <v-flex>
        <v-btn :outline="filter !== 'all'" color="primary" @click="filterBan('all')">
          {{ $t('all') }} ({{ totalCount }})
        </v-btn>
        <v-btn :outline="filter !== 'ban'" color="primary" @click="filterBan('ban')">
          {{ $t('banned') }}
        </v-btn>
        <v-btn :outline="filter !== 'unBan'" color="primary" @click="filterBan('unBan')">
          {{ $t('unbanned') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right pa-1">
        <v-btn @click="resetCustomerBidder()" fab outline small color="primary">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <template>
      <div class="text-xs-right">
        <v-pagination
          :total-visible="10"
          v-model="pageNumber"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>
      <v-data-table
        :loading="loading"
        v-model="selected"
        :headers="headers"
        :items="auctionBidder"
        select-all
        item-key="userid"
        hide-actions
      >
        <template v-slot:headers="props">
          <tr class="text-xs-left">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :style="header.value === 'baned' ? 'text-align: center;' : ''"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            :active="props.index.is_banned"
            :style="`background:${props.index * pageNumber + 1 == 1 ? 'rgb(255 115 177)' : ''}`"
          >
            <td class="text-xs-center" style="position: relative">
              {{ props.index + 1 }}
              <img
                src="/static/img/assets/shop/crown1.png"
                v-if="props.index + 1 == 1"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
            </td>
            <td class="text-xs-left">
              <v-avatar size="30" class="mr-2">
                <img
                  v-if="props.item.user_image_url"
                  :src="props.item.user_image_url"
                  width="30"
                  height="30"
                  :alt="props.item.user_full_name"
                />
                <img
                  v-else
                  :src="'/static/img/assets/livechat/profile.png'"
                  width="30"
                  height="30"
                  :alt="props.item.user_full_name"
                /> </v-avatar
              >{{ props.item.user_full_name }}
            </td>
            <td class="text-xs-left">{{ props.item.auction_price }}</td>
            <td>
              <v-icon style="color:red; cursor: pointer" @click.stop="deleteCustomer(props.item)"
                >delete</v-icon
              >
            </td>
            <td class="text-xs-left">
              <v-progress-circular
                v-if="loadingBan"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-checkbox
                :disabled="!value.is_active"
                v-else
                @click.stop="bannedCustomer(props.item)"
                style="justify-content: center;"
                v-model="props.item.is_banned"
                color="primary"
                hide-details
              ></v-checkbox>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null
    },
    auctionSelected: {
      default: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data() {
    return {
      pageNumber: 1,
      pagelength: 1,
      offset: 0,
      limit: 5,
      totalCount: 0,
      auctionBidder: [],
      headers: [
        {
          text: 'No.',
          value: 'no',
          align: 'center'
        },
        { text: this.$t('facebook_name'), value: 'name', align: 'center' },
        { text: this.$t('bid_price'), value: 'bid', align: 'center' },
        { text: this.$t('Delete'), value: 'delete', align: 'center' },
        { text: this.$t('banned'), value: 'baned', align: 'center' }
      ],
      selected: [],
      loading: false,
      loadingBan: false,
      pagination: {
        sortBy: 'name'
      },
      filter: 'all',
      refreshInterval: null
    }
  },
  beforeDestroy: function() {
    clearInterval(this.refreshInterval)
  },
  mounted() {
    const vm = this
    vm.getCustomerBidder()
    vm.refreshInterval = setInterval(function() {
      vm.getCustomerBidder()
    }, 7000)
  },
  methods: {
    async resetCustomerBidder() {
      const vm = this
      vm.loading = true
      vm.auctionBidder = []
      await vm.getCustomerBidder()
      vm.loading = false
    },
    changePage() {
      const vm = this
      vm.offset = vm.pageNumber * vm.limit - vm.limit
      vm.getCustomerBidder()
    },
    filterBan(type) {
      const vm = this
      vm.filter = type
      vm.getCustomerBidder()
    },
    async getCustomerBidder() {
      const vm = this
      let data = {
        pageId: vm.selectedBot.pageid,
        auctionId: vm.auctionSelected.id,
        productId: vm.value.id,
        param: { offset: vm.offset, limit: vm.limit }
      }
      if (vm.filter !== 'all') {
        data.param.filter_ban = vm.filter === 'ban' ? true : false
      }
      let res = await api.getCustomerBidder(data)

      if (res.success) {
        if (vm.filter === 'all') {
          vm.totalCount = res.total_count
        }
        vm.pagelength = Math.ceil(res.total_count / 10)
        vm.auctionBidder = res.result
      }
    },
    async bannedCustomer(user) {
      const vm = this
      vm.loadingBan = true
      let result = await vm.$swal.fire({
        title: `${vm.$t('do_you_want')} ${!user.is_banned ? 'Ban' : vm.$t('unban')} ${
          user.user_full_name
        } ?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let res = await api.bannedCustomer({
          pageId: vm.selectedBot.pageid,
          auctionId: vm.auctionSelected.id,
          productId: vm.value.id,
          userId: user.userid,
          body: { is_banned: !user.is_banned }
        })
        if (res.success) {
          vm.getCustomerBidder()
          await vm.$swal.fire({
            title: vm.$t(
              `${user.user_full_name} ถูก ${!user.is_banned ? 'Ban' : vm.$t('unban')} ${vm.$t(
                'success'
              )}`
            ),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
      vm.loadingBan = false
    },
    async deleteCustomer(user) {
      const vm = this
      vm.loadingBan = true
      let result = await vm.$swal.fire({
        title: `${vm.$t('do_you_want_to_delete')} ${user.user_full_name} ${vm.$t(
          'from_the_table'
        )}`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let res = await api.deleteCustomer({
          pageId: vm.selectedBot.pageid,
          auctionId: vm.auctionSelected.id,
          productId: vm.value.id,
          userId: user.userid,
          body: { is_banned: !user.is_banned }
        })
        if (res.success) {
          vm.getCustomerBidder()
          await vm.$swal.fire({
            title: `${user.user_full_name} ${vm.$t('has_been_delete')}`,
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
      vm.loadingBan = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/liveAuction/DashboardCustomer.vue